import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { locale as translatableLocale } from "@limitless/common/utils";
import { useTranslation } from "@limitless/common/hooks";
import { useExpertProfileContext } from "@limitless/expert";
import Accordion from "@limitless/modern/surfaces/accordion/Accordion";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";

const TutorialItem = ({ tutorialItemValue, expanded, handleAccorionChange, showDivider }) => {
    const { formatDate } = useExpertProfileContext();
    const { t } = useTranslation();
    const locale = React.useMemo(() => translatableLocale(t, true), []);

    return (
        <Accordion title={tutorialItemValue.title} expanded={expanded} onChange={handleAccorionChange} showDivider={showDivider}>
            <Grid container flexDirection="row" mt={-3}>
                <Typography
                    variant="caption"
                    sx={{ color: theme => theme.palette.grey[4] }}
                    translationSubstitutes={formatDate(new Date(tutorialItemValue.dateAdded), locale)}
                >
                    {"Added on {0}"}
                </Typography>
                <Grid container justifyContent="center" mt={1.51} mb={2.5}>
                    <iframe
                        width="471"
                        height="281"
                        frameBorder="0"
                        src={tutorialItemValue.url}
                        style={{ borderRadius: "12px" }}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};

export default TutorialItem;

TutorialItem.propTypes = {
    tutorialItemValue: PropTypes.object.isRequired,
    handleAccorionChange: PropTypes.func.isRequired,
    expanded: PropTypes.bool.isRequired,
    showDivider: PropTypes.bool
};
